/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Data/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import ProvideData from './ProvideData/index'
import React from 'react'
import ReviewData from './ReviewData/index'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Data({
  children,
  viewPath = "/App/Form/Data"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'ProvideData'
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'ProvideData'}>
<ProvideData
  viewPath={`${viewPath}/ProvideData`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'ReviewData'}>
<ReviewData
  viewPath={`${viewPath}/ReviewData`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}